import { addMessages } from '@hana/i18n';

// Chuỗi giao diện Số liệu hải quan. Mã (VNACCS, HS, TblCustomsData), tên riêng, dữ liệu mẫu không dịch.
addMessages('vi', {
  'cd.noWrite': 'Chưa mở ghi ở bản này',
  'cd.s1': 'Chọn tệp & sheet',
  'cd.rowsN': '{sheet} · {n} dòng',
  'cd.s2': 'Ghép cột',
  'cd.missN': '{n} trường bắt buộc thiếu',
  'cd.allReq': 'đủ {n} trường bắt buộc',
  'cd.s3': 'Kiểm lỗi',
  'cd.errN': '{e} lỗi · {n} người XK mới',
  'cd.s4': 'Ghi theo lô',
  'cd.lots': '14 lô × 500 dòng',
  'cd.backSvc': 'Về Dịch vụ & HS',
  'cd.title': 'Số liệu hải quan',
  'cd.section': 'Mục',
  'cd.tImp': 'Nhập tờ khai',
  'cd.tHist': 'Lịch sử lô',
  'cd.msTip': 'Phân tích thị phần từ cùng nguồn tờ khai (TblCustomsData) nằm ở Market Share',
  'cd.msLink': 'Phân tích ở Market Share ›',
  'cd.totRows': 'dòng · tờ khai xuất',
  'cd.newFile': 'Nhập tệp mới',
  'cd.viewOnly': 'Chỉ xem.',
  'cd.errT': 'Không đọc được dữ liệu hải quan',
  'cd.errD': 'Mất kết nối lúc 10:42 · lô đang ghi dừng ở dòng 2.500, chưa mất dữ liệu.',
  'cd.retry': 'Thử lại',
  'cd.emptyT': 'Chưa có dữ liệu hải quan',
  'cd.emptyD': 'Tải tệp Excel tờ khai VNACCS xuất khẩu để bắt đầu.',
  'cd.importFile': 'Nhập tệp',
  'cd.histSec': 'Lịch sử lô nhập',
  'cd.histH': 'Lô đã nhập',
  'cd.purge': 'Xoá dữ liệu theo kỳ…',
  'cd.thLot': 'Mã lô',
  'cd.thPeriod': 'Kỳ',
  'cd.thRows': 'Số dòng',
  'cd.thErr': 'Lỗi',
  'cd.thBy': 'Người nhập',
  'cd.thStatus': 'Trạng thái',
  'cd.written': 'Đã ghi',
  'cd.undoLot': 'Hoàn tác lô',
  'cd.impSec': 'Nhập tờ khai',
  'cd.dropH': 'Tệp Excel tờ khai VNACCS (xuất khẩu)',
  'cd.fileMeta': '4,8 MB · 3 sheet · tải lúc 10:31',
  'cd.swap': 'Đổi tệp',
  'cd.pickSheet': 'Chọn sheet',
  'cd.sheetAria': 'Sheet',
  'cd.rowsShort': ' · {n} dòng',
  'cd.prevH': 'Xem trước 5 dòng đầu · {sheet}',
  'cd.pDecl': 'Số TK',
  'cd.pDate': 'Ngày',
  'cd.pExp': 'Người XK',
  'cd.pCountry': 'Nước NK',
  'cd.mapSum': '{a} cột tự ghép theo tên · {b} cột ghép tay · ',
  'cd.missSum': '{n} trường bắt buộc chưa ghép',
  'cd.remap': 'Tự ghép lại',
  'cd.colXl': 'Cột trong Excel',
  'cd.colField': 'Trường dữ liệu',
  'cd.colHow': 'Cách ghép',
  'cd.cycleTip': 'Bấm để đổi trường',
  'cd.stepEmptyT': 'Kiểm lỗi · ghi theo lô',
  'cd.stepEmptyD': 'Bước này chưa dựng ở bản này.',
  'cd.back': 'Quay lại',
  'cd.next': 'Tiếp',
});
addMessages('en', {
  'cd.noWrite': 'Writing is not enabled in this version',
  'cd.s1': 'Choose file & sheet',
  'cd.rowsN': '{sheet} · {n} rows',
  'cd.s2': 'Map columns',
  'cd.missN': '{n} required fields missing',
  'cd.allReq': 'all {n} required fields present',
  'cd.s3': 'Check errors',
  'cd.errN': '{e} errors · {n} new exporters',
  'cd.s4': 'Write in lots',
  'cd.lots': '14 lots × 500 rows',
  'cd.backSvc': 'Back to Services & HS',
  'cd.title': 'Customs data',
  'cd.section': 'Section',
  'cd.tImp': 'Import declarations',
  'cd.tHist': 'Lot history',
  'cd.msTip': 'Market-share analysis from the same declaration source (TblCustomsData) lives in Market Share',
  'cd.msLink': 'Analyse in Market Share ›',
  'cd.totRows': 'rows · export declarations',
  'cd.newFile': 'Import new file',
  'cd.viewOnly': 'View only.',
  'cd.errT': 'Cannot read customs data',
  'cd.errD': 'Connection lost at 10:42 · the lot being written stopped at row 2,500, no data lost.',
  'cd.retry': 'Retry',
  'cd.emptyT': 'No customs data yet',
  'cd.emptyD': 'Upload a VNACCS export declaration Excel file to begin.',
  'cd.importFile': 'Import file',
  'cd.histSec': 'Import lot history',
  'cd.histH': 'Imported lots',
  'cd.purge': 'Delete data by period…',
  'cd.thLot': 'Lot ID',
  'cd.thPeriod': 'Period',
  'cd.thRows': 'Rows',
  'cd.thErr': 'Errors',
  'cd.thBy': 'Imported by',
  'cd.thStatus': 'Status',
  'cd.written': 'Written',
  'cd.undoLot': 'Undo lot',
  'cd.impSec': 'Import declarations',
  'cd.dropH': 'VNACCS declaration Excel file (export)',
  'cd.fileMeta': '4.8 MB · 3 sheets · uploaded 10:31',
  'cd.swap': 'Change file',
  'cd.pickSheet': 'Choose sheet',
  'cd.sheetAria': 'Sheet',
  'cd.rowsShort': ' · {n} rows',
  'cd.prevH': 'Preview first 5 rows · {sheet}',
  'cd.pDecl': 'Decl. no.',
  'cd.pDate': 'Date',
  'cd.pExp': 'Exporter',
  'cd.pCountry': 'Dest. country',
  'cd.mapSum': '{a} columns auto-mapped by name · {b} mapped manually · ',
  'cd.missSum': '{n} required fields unmapped',
  'cd.remap': 'Auto-map again',
  'cd.colXl': 'Excel column',
  'cd.colField': 'Data field',
  'cd.colHow': 'Mapped by',
  'cd.cycleTip': 'Click to change field',
  'cd.stepEmptyT': 'Check errors · write in lots',
  'cd.stepEmptyD': 'This step is not built in this version.',
  'cd.back': 'Back',
  'cd.next': 'Next',
});
